import React, { memo, useCallback, useContext } from "react";
// types
import { COUPON_CARD_COMMS_TYPES, ICouponSectionComm } from "@swiggy-private/cart-types";
// components
import { CouponFooterSection, CouponHeaderSection } from "@swiggy-private/cart-ui";
// contexts
import { CouponRendererContext } from "@cart-client/contexts/CouponRendererContext";
// hooks
import { useSavingsText } from "@cart-client/hooks/useSavingsText";
// helpers
import { buildApplyCouponClickAnalyticsPayload } from "@cart-client/helpers/Coupon";

const CouponSectionComms = ({ type, comms }: ICouponSectionComm) => {
    const {
        updateGiftingCouponHandler,
        appliedCouponCodes = [],
        isFooterDisabled = true,
        isCouponAvailable = false,
        couponApplied = false,
        coupons,
        giftingAnalytics,
    } = useContext(CouponRendererContext);

    const { savingsText } = useSavingsText({
        appliedCouponCodes,
        templateData: comms,
        coupons,
        hasUserChangedCoupons: !couponApplied,
    });

    const handleFooterCTAClick = useCallback(() => {
        const payload = buildApplyCouponClickAnalyticsPayload({
            coupons,
            appliedCouponCodes,
            savingsText,
            couponApplied,
        });

        giftingAnalytics.handleApplyCouponClick?.(payload);
        updateGiftingCouponHandler({});
    }, [giftingAnalytics, appliedCouponCodes, coupons, savingsText, couponApplied, updateGiftingCouponHandler]);

    switch (type) {
        case COUPON_CARD_COMMS_TYPES.HEADER_COMMS:
            return <CouponHeaderSection {...comms} />;
        case COUPON_CARD_COMMS_TYPES.FOOTER_COMMS:
            return (
                <CouponFooterSection
                    savingsText={savingsText}
                    isCouponAvailable={isCouponAvailable}
                    onFooterCTAClick={handleFooterCTAClick}
                    isFooterCTAdisabled={isFooterDisabled}
                    couponApplied={couponApplied}
                    CTAImpression={giftingAnalytics.handleApplyCouponImpression}
                />
            );
        default:
            return null;
    }
};

export default memo(CouponSectionComms);
